export const CODE_PATTERN = /^[A-Za-z0-9][A-Za-z0-9 _-]*$/;

export const validateCode = (code, { isUpdate, label = "Code" }) => {
  if (isUpdate) return "";

  const value = String(code || "").trim();
  if (!value) return `${label} is required`;
  if (value.length < 2) return `${label} needs at least 2 characters`;
  if (value.length > 60) return `${label} may be at most 60 characters`;
  if (!CODE_PATTERN.test(value)) {
    return `${label} may use letters, digits, spaces, hyphens and underscores only`;
  }
  return "";
};

export const validateRequired = (value, label) =>
  String(value || "").trim() ? "" : `${label} is required`;

export const numberOrNull = (value) => (value === "" ? null : Number(value));

export const isSet = (value) => value !== "" && value !== null && value !== undefined;

export const validateRange = (min, max, label) =>
  isSet(min) && isSet(max) && Number(max) < Number(min)
    ? `${label} maximum must not be below the minimum`
    : "";

export const validateExternalCodes = (rows) =>
  (rows || []).some((row) => !String(row.code || "").trim())
    ? "Every external code row needs a code value"
    : "";
